// Per-account form-builder defaults.
//
// AGORA is one-deploy-per-tenant, but the codebase is shared across tenants, so we
// cannot flip a global default (CEA/Mexico tenants rely on 'mx'). Instead we map the
// few accounts that have a fixed locale here. Account 11 ("Venezuela" / Reencuentro)
// is an all-Venezuela deployment, so address fields should bias to Venezuela by
// default — autocomplete region + initial map center — without an operator picking it.
const ACCOUNT_DEFAULT_COUNTRY = {
  11: 'VE', // Venezuela — Reencuentro disaster-relief account
};

// Global fallback when an account has no override (matches the renderer's 'mx').
export const FALLBACK_FORM_COUNTRY = 'MX';

// Returns the ISO country code (uppercase) new address fields should default to for
// the given account. Accepts string/number ids.
export function defaultFormCountry(accountId) {
  return ACCOUNT_DEFAULT_COUNTRY[Number(accountId)] || FALLBACK_FORM_COUNTRY;
}
